module.exports = __webpack_public_path__ + "static/media/iconSurprised.d60e2a78.svg";